import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

import { MUIBreakpointLg } from '../../constants';

export const StyledDropdownMenu = styled.div`
  width: 100%;

  @media screen and (min-width: ${MUIBreakpointLg}) {
    display: inline-block;
    position: relative;
  }

  .MenuBody {
    background-color: ${token('colors.gray100')};
    border-top: 1px solid ${token('colors.gray300')};
    border-bottom: none;
    display: flex; // needed to prevent margins from collapsing
    flex-flow: column nowrap; // needed to prevent margins from collapsing
    padding-bottom: 28px;
    padding-top: 20px;
    position: relative;
    z-index: 2;

    @media screen and (min-width: ${MUIBreakpointLg}) {
      background: ${token('colors.white')};
      border-radius: 3px;
      box-shadow: rgb(0 0 0 / 20%) 0 0 10px 0;
      max-height: 438px;
      max-width: 430px;
      min-width: 200px;
      margin-top: -1px;
      padding-bottom: ${spaceMixin('xs')};
      padding-top: ${spaceMixin('xs')};
    }
  }

  .MenuBody-wrapper {
    position: relative;

    @media screen and (min-width: ${MUIBreakpointLg}) {
      display: inline-flex;
      flex-flow: column;
      position: absolute;
      right: 0;
      top: ${spaceMixin('sm')};
    }
  }

  .MenuBody-triangle {
    display: none;

    @media screen and (min-width: ${MUIBreakpointLg}) {
      align-self: flex-end;
      display: block;
      height: 36px;
      overflow: hidden;
      position: relative;
      right: 18px;
      width: 36px;
      z-index: 3;
    }
  }

  .MenuBody-triangle::after {
    display: none;

    @media screen and (min-width: ${MUIBreakpointLg}) {
      background: ${token('colors.white')};
      box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.2);
      content: '';
      display: block;
      height: 18px;
      left: 10px;
      position: absolute;
      top: 28px;
      transform: rotate(45deg);
      width: 18px;
    }
  }

  .MenuItem {
    cursor: pointer;
    display: flex;
    flex-flow: column wrap;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.5;
    margin-bottom: 4px;
    margin-top: 4px;
    padding: 8px 12px;
    width: 100%;
    text-align: left;

    & a {
      color: ${token('colors.brand')} !important;
      text-decoration: none;
      position: relative;
      z-index: 1;
      padding: 1em;
      margin: -1em;

      @media screen and (min-width: ${MUIBreakpointLg}) {
        color: ${token('colors.textDark')} !important;
        align-items: center;
        display: flex;
        justify-content: space-between;
      }
    }

    span {
      svg {
        height: 16px;
        width: 16px;
      }
    }

    @media screen and (min-width: ${MUIBreakpointLg}) {
      background: ${token('colors.white')};
      color: ${token('colors.gray600')};
      cursor: pointer;
      display: flex;
      font-weight: 600;
      padding: ${spaceMixin('xs')} ${spaceMixin('md')};
      width: auto;
    }
  }

  .MenuItem.MenuItem-divider {
    border-top: 1px solid ${token('colors.gray300')};
  }

  .MenuItem:hover {
    @media screen and (min-width: ${MUIBreakpointLg}) {
      background: ${token('colors.blue200')};
    }
  }
`;
